export class SessionReConnectingAction {
  static readonly type = '[Session] re-connecting to server stream';
}
